import Banner from "../../sections/common/banner";
import { useLangagesStore } from "../../../context/langages";
import { data as dataES } from "../../../globals/data/es/terms-conditions-use.js";
import { data as dataEN } from "../../../globals/data/en/terms-conditions-use.js";
import { data as dataCN } from "../../../globals/data/zh/terms-conditions-use.js";
import SectionTermsConditionsUse from "../../sections/home/index/section-terms-conditions-use";


export default function TermsConditionsUsePage() {
    const language = useLangagesStore((state) => state.langage);
    const data = language === "en" ? dataEN : language === "cn" ? dataCN : dataES;

    return (
        <>
            <Banner _data={data.banner} />
            <SectionTermsConditionsUse _data={data} />
        </>
    )
}